const homeColumns=[
    {
        title: 'Managed Devices',
        accessor: 'deviceCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Total Softwares',
        accessor: 'softwareCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Prohibited Softwares',
        accessor: 'prohibitedSoftwareCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Missing Patches',
        accessor: 'missingPatchesCount',
        unsearchable: true,
        unsortable: true,
    }
]
const inventoryColumns=[
    {
        title: 'Managed Devices',
        accessor: 'deviceCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Total Softwares',
        accessor: 'softwareCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Prohibited Softwares',
        accessor: 'prohibitedSoftwareCount',
        unsearchable: true,
        unsortable: true,
    }
]
const patchColumns=[
    {
        title: 'Managed Devices',
        accessor: 'deviceCount',
        unsearchable: true,
        unsortable: true,
    },
    {
        title: 'Missing Patches',
        accessor: 'missingPatchesCount',
        unsearchable: true,
        unsortable: true,
    }
]
export const moduleMappingForCustomerSummary={
    "home": homeColumns,
    "inventory": inventoryColumns,
    "patch":patchColumns
}